<!--
  单笔话费流量充值
  lovi 2020-07-08
 -->
<template>
  <div class="w100">
    <van-nav-bar class="gradient" :fixed="true" left-arrow @click-left="_back">
      <template slot="title">
        <span :class="{ active: flag == 5 }" @click="changeType(5)">
          {{ $t("recharge.phoneFee") }}
        </span>
        <span :class="{ active: flag == 6 }" @click="changeType(6)">
          {{ $t("recharge.dataTraffic") }}
        </span>
      </template>
      <span slot="right" @click="_linkFun('/record', 'record', { flag: flag })">
        {{ $t("common.rechargeRecord") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div
          class="mask"
          v-if="historyFlag"
          @click="historyFlag = false"
          :style="
            `top:${
              operator_recharge && operator_recharge.amount_mini
                ? '50px'
                : '35px'
            }`
          "
        ></div>
        <div class="recharge">
          <div class="input-tel column">
            <div class="input-box">
              <van-field
                v-model="phone"
                type="tel"
                :maxlength="telMax"
                @focus="fieldFocus"
                @input="fieldInput"
                :placeholder="$t('common.enterMobile')"
              >
                <van-icon
                  slot="right-icon"
                  name="clear"
                  v-if="phone != ''"
                  @click="clearTel"
                />
              </van-field>
              <van-cell-group class="history-group" v-if="historyFlag">
                <van-cell
                  v-for="(item, index) in historyList"
                  :key="index"
                  :title="_phoneFormat(item.tel)"
                  :label="item.name"
                  @click="chooseHistory(item)"
                />
                <a class="clear-history" @click="cleanRecord">
                  {{ $t("common.clearHistory") }}
                </a>
              </van-cell-group>
            </div>
            <div class="input-tips">
              <span :class="operatorId == -1 ? 'text-red' : 'text-gray'">
                <template v-if="phone && operatorId == -1">
                  {{ $t("recharge.phoneNumberError") }}
                </template>
                <template v-if="operatorId > 0">
                  {{
                    phone.replace(/\s/g, "") == userInfo.phone
                      ? $t("recharge.defaultNumber")
                      : ""
                  }}
                  ({{ operatorName }})
                </template>
              </span>
              <i class="text-blue" v-if="flag == 5" @click="balanceFlag = true">
                {{ $t("recharge.balanceQuery") }}
              </i>
            </div>
          </div>

          <template v-if="flag == 5">
            <div class="column money-column" v-if="denomination.length">
              <div class="title">
                <h3>{{ $t("recharge.phoneChargeOptionalAmount") }}</h3>
              </div>
              <money-list
                :money.sync="money"
                :moneyId.sync="moneyId"
                :list="denomination"
                :custom="operator_recharge"
                :rate="Number(curPay.exchange_rate)"
                :recently="recently"
              />
            </div>
            <div v-else class="column no-operator text-gray">
              {{ $t("recharge.operatorNotSupport") }}
            </div>
          </template>
          <template v-else>
            <van-cell-group
              v-if="operatorState[operatorId] == 1"
              class="column combo-column"
            >
              <van-cell
                :title="$t('recharge.dataChargeSelectPackage')"
                is-link
                @click="clickCombo"
              />
              <van-cell
                v-if="comboInfo.denomination_id"
                :title="comboInfo.content"
                :value="comboInfo.amount + 'P'"
              />
            </van-cell-group>
            <div v-else class="column no-operator text-gray">
              {{ $t("recharge.operatorNotSupport") }}
            </div>
          </template>

          <!-- 选择支付方式 -->
          <pay-list
            :money.sync="money"
            :showDiscount="flag == 5 ? true : false"
            @getCurPay="getCurPay"
          />
          <div class="button-wrap">
            <van-button block type="primary" @click="submit">
              {{ $t("common.rechargeNow") }}
            </van-button>
            <p class="tips">
              {{ $t("common.payFeesTips") }}
            </p>
          </div>
        </div>
      </scroll>
    </div>

    <van-popup v-model="balanceFlag" class="balance-popup" get-container="body">
      <ul>
        <li>{{ $t("recharge.callChargesInquiry") }}</li>
        <li @click="getBalance('Globe')">Globe</li>
        <li @click="getBalance('Smart')">Smart</li>
        <li @click="getBalance('Sun')">Sun</li>
        <li @click="balanceFlag = false">{{ $t("common.cancel") }}</li>
      </ul>
    </van-popup>

    <transition name="slide">
      <combo
        v-if="comboFlag"
        :comboFlag.sync="comboFlag"
        :operatorId.sync="operatorId"
        @getComboInfo="getComboInfo"
      />
    </transition>

    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="paycalls"
    />
  </div>
</template>

<script>
import MoneyList from "@/components/moneyList";
import Combo from "@/components/recharge/combo";
import PayList from "@/components/payList";
import EnterPayPsd from "@/components/enterPayPsd";
import { mapGetters } from "vuex";
export default {
  name: "single",
  props: {},
  components: {
    MoneyList,
    PayList,
    Combo,
    EnterPayPsd
  },
  data() {
    return {
      flag: 5, //充值类型，5话费，6流量
      phone: "", //手机号
      telMax: 12, //输入框号码长度
      callInfo: {}, //充值信息
      historyList: [], //充值号码历史记录
      historyFlag: false,
      operatorList: [], //运营商列表
      operatorName: "", //当前运营商名称
      operatorId: 0, //当前运营商类型标识
      balanceFlag: false, //余额查询弹窗
      phoneQuery: [],
      operatorState: {}, //运营商支持流量套餐状态
      allMoney: {}, //全部金额面板
      denomination: [], //金额面板
      operator_recharge: {}, //自定义金额
      recently: "", // 最近充值金额
      money: 0, // 金额
      moneyId: 0, //话费金额Id
      comboFlag: false, //选择套餐
      comboInfo: {}, //套餐选择的信息
      curPay: {}, //当前支付方式
      // 支付密码
      payPsdFlag: false,
      payPsdData: {
        money: ""
      }
    };
  },
  created() {
    this.flag = this.$route.query.flag || 5;
    this._getCalls();
    this._getPhoneQuery();
    this.operatorDataPackageState();
    this._getCallsDenomination();
  },
  mounted() {
    if (this.userInfo) {
      this.phone = this.userInfo.phone ? this.userInfo.phone : "";
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    changeType(flag) {
      //切换类型
      console.log("changeType", flag);
      let vm = this;
      if (vm.flag == flag) {
        return false;
      }
      vm.flag = flag;
      vm.money = 0;
      vm.comboInfo = {};
      vm._getCalls();
      vm.$router.replace({
        path: "/single",
        name: "single",
        query: { flag: flag }
      });
    },
    getCurPay(data) {
      //获取当前支付信息
      let vm = this;
      vm.curPay = data;
      console.log("curPay", vm.curPay);
    },
    clearTel() {
      //清空号码
      let vm = this;
      vm.phone = "";
      vm.fieldInput(vm.phone);
    },
    getBalance(type) {
      //余额查询
      let vm = this;
      let obj = {};
      if (type == "Globe") {
        obj = vm.phoneQuery.Globe;
        obj.type = "sms";
      } else if (type == "Smart") {
        obj = vm.phoneQuery.Smart;
        obj.type = "sms";
      } else if (type == "Sun") {
        obj = vm.phoneQuery.Sun;
        obj.type = "tel";
      }
      vm.textOrCall(obj);
    },
    textOrCall(obj) {
      //发短信、打电话
      let phone = obj.phone;
      let name = obj.content;
      let u = navigator.userAgent;
      // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
      let isiOS =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1; //ios终端
      let sendcontent = "";
      if (obj.type == "tel") {
        // 打电话
        sendcontent = "tel:" + phone;
      } else {
        // 发短信
        sendcontent = "sms:" + phone + (isiOS ? "&" : "?") + "body=" + name;
      }
      console.log("textOrCall", sendcontent);
      window.location.href = sendcontent;
    },
    fieldFocus() {
      //输入框获得焦点
      let vm = this;
      console.log(vm.phone);
      if (vm.phone == "" && vm.historyList.length) {
        vm.historyFlag = true;
      }
    },
    fieldInput(value) {
      //输入号码
      let vm = this;
      if (value == "") {
        vm.phone = "";
        vm.operatorName = "";
        vm.operatorId = -1;
        vm.fieldFocus();
        return;
      }
      //输入手机号后，先判断第一个字符是否为0
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        vm.telMax = 13;
        vm.phone = vm._phoneFormat(value);
      } else {
        //否则输入框最多输入12位
        vm.telMax = 12;
        vm.phone = vm._phoneFormat(value);
      }
      //如果当前输入的个数为vm.telMax个时，则去判断号码的运营商
      if (vm.phone.length == vm.telMax) {
        vm.judgeOperator();
        vm.historyFlag = false;
      } else {
        vm.operatorName = "";
        vm.operatorId = -1;
        vm.money = 0;
        vm.moneyId = 0;
      }
    },
    chooseHistory(obj) {
      //选择历史记录的号码
      let vm = this;
      vm.phone = vm._phoneFormat(obj.tel);
      vm.historyFlag = false;
      vm.judgeOperator();
    },
    cleanRecord() {
      //清除历史号码
      let vm = this;
      let params = {};
      params.type = vm.flag;
      vm.$post("/app/recharge/cleanRecord", params, { loading: true }).then(
        res => {
          console.log("cleanRecord", res);
          vm.historyList = [];
          vm.historyFlag = false;
        }
      );
    },
    clickCombo() {
      //选择套餐
      let vm = this;
      if (vm.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      if (vm.operatorId == -1) {
        vm.$toast(vm.$t("recharge.phoneNumberError"));
        return false;
      }
      if (vm.operatorName == "Smart" || vm.operatorName == "smart") {
        vm.$dialog
          .confirm({
            title: vm.$t("common.tips"),
            message: vm.$t("recharge.pleaseSelectOperator"),
            confirmButtonText: "Tnt",
            cancelButtonText: "Smart",
            cancelButtonColor: "#FE7800"
          })
          .then(() => {
            // Tnt
            vm.operatorId = 4;
            vm.comboFlag = true;
          })
          .catch(() => {
            // Smart
            vm.comboFlag = true;
          });
        return false;
      }
      vm.comboFlag = true;
    },
    getComboInfo(data) {
      //获取套餐信息
      let vm = this;
      vm.comboInfo = data;
      vm.money = Number(data.amount);
      vm.comboFlag = false;
    },
    submit() {
      //充值第一步,先做判断
      let vm = this;
      if (vm.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      if (vm.operatorId == -1) {
        vm.$toast(vm.$t("recharge.phoneNumberError"));
        return false;
      }
      if (vm.flag == 5 && !vm.denomination.length) {
        vm.$toast(vm.$t("recharge.operatorNotSupport"));
        return false;
      }
      if (vm.flag == 6) {
        if (vm.operatorState[vm.operatorId] == 0) {
          vm.$toast(vm.$t("recharge.operatorNotSupport"));
          return false;
        }
        if (!vm.comboInfo.denomination_id) {
          //流量充值
          vm.$toast(vm.$t("recharge.pleaseSelectPackage"));
          return false;
        }
      }
      if (vm.flag == 5) {
        //话费充值
        if (vm.money == "" || vm.money == 0) {
          //判断金额是否为空
          vm.$toast(vm.$t("common.enterAmount"));
          return false;
        }
        //判断金额是否在允许范围内
        if (vm.operator_recharge && vm.operator_recharge.amount_mini) {
          if (vm.money < Number(vm.operator_recharge.amount_mini)) {
            vm.$toast(
              vm.$t("common.amountCannotMin") + vm.operator_recharge.amount_mini
            );
            return;
          }
          if (vm.money > Number(vm.operator_recharge.amount_max)) {
            vm.$toast(
              vm.$t("common.amountCannotMax") + vm.operator_recharge.amount_max
            );
            return;
          }
        }
      }

      if (vm.curPay.type == 3) {
        //余额充值
        if (vm.money > Number(vm.userInfo.money_usable)) {
          vm.$toast(vm.$t("recharge.insufficientBalanceChooseOtherPay"));
          return false;
        }
        vm.payPsdData.money = vm.money.toFixed(2);
        vm.payPsdFlag = true;
      } else {
        //微信充值
        vm.paycalls();
      }
    },
    paycalls(payPsd) {
      //立即充值
      let vm = this;
      let params = {};
      params.type = vm.flag;
      params.phone = "0" + Number(vm.phone.replace(/\s/g, ""));
      params.amount = vm.money;
      params.denomination_id =
        vm.flag == 5 ? vm.moneyId : vm.comboInfo.denomination_id;
      params.pay_password = payPsd;
      params.payment_id = vm.curPay.payment_id; //支付方式，3.余额、5.微信扫码支付
      vm.$post("/app/recharge/paycalls", params, {
        loading: true
      }).then(res => {
        console.log("paycalls", res);
        console.log("vm", vm.curPay.type);
        let routeData = res;
        if (vm.curPay.type == 3) {
          // 3.余额
          routeData.button = true;
          vm.$router.push({
            path: "/detail",
            name: "detail",
            query: {
              flag: vm.flag,
              order_id: res.order_id
            },
            params: routeData
          });
        }
        if (vm.curPay.type == 5) {
          // 5.微信扫码支付
          routeData.money = vm.money.toFixed(2) + "P";
          vm.$router.push({
            path: "/payCode",
            name: "payCode",
            query: { flag: vm.flag, payType: vm.curPay.type },
            params: routeData
          });
        }
        if (vm.curPay.type == 2||vm.curPay.type == 10) {
          //支付宝app付
          /* eslint-disable */
          if(vm.curPay.type == 10)
          {
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: vm.flag,
                order_id: res.order_id
              },
              params: routeData
            });

          }
          else {
            jsBridge.aliPay({
              orderString: res.return_charge.query
            }, function(succ, text) {
              if (succ) {
                alert("支付成功");
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: vm.flag,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {
                alert("支付失败或取消了支付");
              }

            });
          }
        }
        if (vm.curPay.type == 1) {
          //微信app付
          /* eslint-disable */
        if(vm.enter=="wechat")
        {


          window.location.href=res.return_charge.content;

          routeData.button = true;
          vm.$router.push({
            path: "/detail",
            name: "detail",
            query: {
              flag: vm.flag,
              order_id: res.order_id
            },
            params: routeData
          });


        }
        else {
          jsBridge.wxPay({
            appid: res.return_charge.appid,
            partnerid: res.return_charge.partnerid,
            prepayid: res.return_charge.prepayid,
            package: res.return_charge.package,
            noncestr: res.return_charge.noncestr,
            timestamp: res.return_charge.timestamp,
            sign: res.return_charge.sign
          }, function(succ, text) {
            if (succ) {
              routeData.button = true;
              vm.$router.push({
                path: "/detail",
                name: "detail",
                query: {
                  flag: vm.flag,
                  order_id: res.order_id
                },
                params: routeData
              });
            } else {

            }
          });
        }
        }
      });
    },
    _getCalls() {
      // 获取充值信息
      let vm = this;
      let params = {};
      params.type = vm.flag;
      vm.$post("/app/recharge/calls", params, { loading: true }).then(res => {
        console.log("calls", res);
        vm.callInfo = res;
        vm.historyList = res.record;
      });
    },
    _getPhoneQuery() {
      //查询话费电话和内容
      let vm = this;
      vm.$post("/app/help/phoneQuery", {}, { loading: true }).then(res => {
        console.log("phoneQuery", res);
        vm.phoneQuery = res.list;
      });
    },
    operatorDataPackageState() {
      // 运营商支持流量套餐状态
      let vm = this;
      vm.$post(
        "/app/recharge/operatorDataPackageState",
        {},
        { loading: true }
      ).then(res => {
        console.log("operatorDataPackageState", res);
        vm.operatorState = res;
      });
    },
    _getCallsDenomination() {
      // 话费充值面板
      let vm = this;
      vm.$post(
        "/app/recharge/callsDenomination",
        { type: 5 },
        { loading: true }
      ).then(res => {
        console.log("callsDenomination", res);
        vm.allMoney = res.list;
        vm._getFetchOperatorPre();
      });
    },
    _getFetchOperatorPre() {
      //获取运营商字段
      let vm = this;
      vm.$post(
        "/app/index/fetchOperatorPre",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("fetchOperatorPre", res);
        vm.operatorList = res.list;
        if (vm.phone != "") {
          vm.fieldInput(vm.phone);
        }
      });
    },
    judgeOperator() {
      //手机号码判断运营商
      let vm = this;
      let phone = "0" + Number(vm.phone.replace(/\s/g, ""));
      for (let i = 0; i < vm.operatorList.length; i++) {
        if (phone.indexOf(vm.operatorList[i].tel) == 0) {
          vm.operatorName = vm.operatorList[i].name;
          vm.operatorId = vm.operatorList[i].operator_id;
          console.log(vm.operatorName, vm.operatorId);
          if (vm.flag == 5) {
            vm.denomination = vm.allMoney[vm.operatorId].denomination;
            vm.operator_recharge = vm.allMoney[vm.operatorId].operator_recharge;
            vm.recently = vm.allMoney[vm.operatorId].previous_record;
          }
          break;
        } else {
          vm.operatorName = "";
          vm.operatorId = -1;
        }
      }
    }
  },
  watch: {
    userInfo() {
      this.phone = this.userInfo.phone;
    }
  }
};
</script>

<style lang="less" scoped>
.no-operator {
  padding: 15px 10px;
  text-align: center;
  font-size: 14px;
}
/deep/.van-nav-bar__title {
  span {
    margin-left: 12px;
    color: rgba(255, 255, 255, 0.5);
    &:first-child {
      margin-left: 0;
    }
    &.active {
      color: #fff;
    }
  }
}

.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
  .recharge {
    padding: 1.1px 0;
  }
}
.input-tel {
  overflow: initial;
  position: relative;
  z-index: 11;
  .input-box {
    padding: 0 10px;
    position: relative;
    /deep/.van-cell {
      padding: 10px 0;
      font-size: 20px;
      &:after {
        left: 0;
      }
      .van-field__right-icon .van-icon {
        font-size: 20px;
        color: #ccc;
      }
    }
    .history-group {
      position: absolute;
      left: 0;
      right: 0;
      padding: 0 10px;
      z-index: 20;
      border-radius: 0 0 8px 8px;
      .van-cell {
        font-size: 14px;
        /deep/.van-cell__title {
          line-height: 1;
        }
        /deep/.van-cell__label {
          margin-top: 2px;
          color: #2042ab;
          font-size: 12px;
          line-height: 1;
        }
      }
      .clear-history {
        display: block;
        padding: 10px 0;
        line-height: 1;
        color: #fe7800;
        font-size: 14px;
        text-align: center;
      }
    }
    .van-hairline--top-bottom::after {
      border-width: 0;
    }
  }
  .input-tips {
    padding: 0 10px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      text-decoration: underline;
    }
  }
}

.money-column {
  padding: 10px;
  .title {
    padding: 0;
  }
}

.combo-column {
  .van-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:first-child {
      .van-cell__title {
        color: #4a4a4a;
      }
      .van-cell__value {
        color: #9b9b9b;
      }
    }
    &::after {
      left: 0;
    }
    .van-cell__title {
      font-size: 14px;
      display: flex;
      align-items: center;
      color: #9b9b9b;
      overflow: hidden;
      span {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .van-cell__value {
      flex: initial;
      font-size: 16px;
      color: #4a4a4a;
    }
  }
}

.mask {
  position: absolute;
  top: 35px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
}
.balance-popup {
  width: 255px;
  overflow: hidden;
  border-radius: 8px;
  ul li {
    text-align: center;
    padding: 5px;
    line-height: 18px;
    font-size: 14px;
    border-top: 1.1px solid #e4e4e4;
    &:first-child {
      border-top: 0;
    }
  }
}
</style>
